<template>
  <div id="app">
    <router-view/>
    <!-- <h1>你好</h1> -->
  </div>
</template>

<script>
export default {
  name: 'App'
}

</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
.page-loading-img{
  // background-image:url('./assets/img/loading.jpg');
  color:#fff;
}

body,html{
    height: 100%;
    font-weight: normal;
    background: #fff;
    line-height: 1;
    font-size: 16px;
    overflow: hidden
}
</style>
